import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InteractionService {
  private lastInteractionTime: number;
  private interactionTimeout = 60 * 1_000;
  private interactionEvents = ['mousemove', 'keydown', 'click', 'touchstart'];
  private interactionListener = this.resetInteractionTime.bind(this);
  private debounceTimeout = 300;
  private debounceTimer: NodeJS.Timeout;

  constructor() {
    this.lastInteractionTime = Date.now();
    this.setupInteractionMonitor();
  }

  private setupInteractionMonitor() {
    // set up events listeners that reset the interaction time
    this.interactionEvents.forEach(event => {
      window.addEventListener(event, this.interactionListener, { passive: true });
    });
  }

  private resetInteractionTime() {
    // debounced resetting of interaction time to current
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.lastInteractionTime = Date.now();
    }, this.debounceTimeout);
  }

  public isAppStuck(): boolean {
    const currentTime = Date.now();
    return currentTime - this.lastInteractionTime > this.interactionTimeout;
  }

  ngOnDestroy() {
    // remove events listeners on service destruction
    this.interactionEvents.forEach(event => {
      window.removeEventListener(event, this.interactionListener);
    });
  }
}
